var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbhaIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4195_3341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.625 1.91602C12.7466 1.91579 11.8804 2.12133 11.0958 2.51615C10.3112 2.91098 9.62992 3.48411 9.10667 4.18963C8.58343 4.89514 8.23272 5.71341 8.08266 6.57887C7.93261 7.44433 7.98737 8.33291 8.24256 9.17339L1.75 15.666V19.416H5.5L11.9926 12.9234C12.7663 13.1583 13.5815 13.2237 14.3828 13.115C15.184 13.0063 15.9524 12.7262 16.6356 12.2937C17.3188 11.8611 17.9007 11.2864 18.3417 10.6087C18.7826 9.9309 19.0723 9.16604 19.1909 8.3662C19.3095 7.56636 19.2543 6.75035 19.029 5.97379C18.8038 5.19722 18.4137 4.47835 17.8854 3.86618C17.3572 3.254 16.7032 2.76291 15.9679 2.42637C15.2327 2.08983 14.4336 1.91576 13.625 1.91602ZM13.625 11.916C13.1946 11.9158 12.7667 11.8521 12.3549 11.7271L11.6381 11.5098L11.1086 12.0393L9.12044 14.0275L8.25881 13.166L7.375 14.0498L8.23669 14.9115L7.2455 15.9027L6.38381 15.041L5.5 15.9248L6.36169 16.7865L4.98225 18.166H3V16.1838L9.12644 10.0573L9.65594 9.5277L9.43888 8.81102C9.17174 7.93038 9.18909 6.98793 9.48847 6.11773C9.78786 5.24753 10.354 4.49389 11.1064 3.96401C11.8588 3.43414 12.7592 3.15502 13.6794 3.16635C14.5995 3.17768 15.4927 3.47889 16.2319 4.02713C16.971 4.57537 17.5184 5.34272 17.7963 6.22003C18.0742 7.09734 18.0683 8.03993 17.7796 8.91372C17.4908 9.78751 16.9339 10.548 16.188 11.087C15.4421 11.626 14.5453 11.9161 13.625 11.916Z",
    fill: "#192852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 8.16602C14.9404 8.16602 15.5 7.60637 15.5 6.91602C15.5 6.22566 14.9404 5.66602 14.25 5.66602C13.5596 5.66602 13 6.22566 13 6.91602C13 7.60637 13.5596 8.16602 14.25 8.16602Z",
    fill: "#192852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4195_3341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.666016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbhaIcon2);
export default __webpack_public_path__ + "static/media/abha-icon2.a1dbf6d4701b9ee536c667be3e0df6bc.svg";
export { ForwardRef as ReactComponent };